import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Heading } from 'src/components/Form';
import Button from 'src/components/Button';
import Callout from 'src/components/InformationCallout/Callout';
import ChangePasswordDialogue from 'src/components/ChangePasswordDialogue';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import '../../Settings.scss';

export const PasswordSection: React.FC = () => {
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  const user: any = useSelector(selectAuthenticatedUser);

  return (
    <div className="settingsSection">
      <Heading>Password Settings</Heading>
      <Callout
        variant="info"
        title="Change your password"
        subtitle="Click the button below to open a dialogue where you can update your password."
      />
      <div className="settingsChangePassword">
        <Button
          label="Change Password"
          size="small"
          color="teal"
          type="button"
          onClick={() => setIsChangePasswordOpen(true)}
        />
      </div>
      <ChangePasswordDialogue
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
        userId={user?.id ?? ''}
        email={user?.email ?? ''}
      />
    </div>
  );
};

export default PasswordSection;
